import React, { useEffect, useState } from 'react'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import { styled } from '@mui/material'
import { Typography } from '@mui/material'

import StyledModal from '../../../components/StyledModal/StyledModal'
import StyledSelectField from '../../../components/StyledSelectField/StyledSelectField'

const StyledTextArea = styled('textarea')(() => ({
  border: '1px solid gray',
  borderRadius: '6px',
  padding: '12px',
  resize: 'none',
  '&::placeholder': {
    fontSize: '14px',
    fontFamily: 'Inter'
  }
}))

const AddMttrMtbfFilterModal = (props) => {
  const defaultParameter = {
    value: 0,
    label: 'Select  parameter'
  }

  const [parameter, setParameter] = useState(defaultParameter)
  const [filterMins, setFilterMins] = useState('')

  useEffect(() => {
    console.log('checking data', parameter, props.defaultData)
    if (props.defaultData && parameter.value !== 0) {
      setFilterMins(
        props.defaultData
          .filter((item) => item.parameter === parameter.value)
          .map((item) => item.filterOption)
          .join(', ')
      )
    }
  }, [parameter, props.defaultData])

  const handleSave = () => {
    const filterDataArray = filterMins.split(',').map(Number)

    const data = {
      parameter: parameter.value,
      filterData: filterDataArray
    }
    props.primaryAction(data)
    props.closeHandler()
  }

  return (
    <StyledModal
      modalWidth={500}
      loaderState={props.isLoading}
      isModalOpen={props.isModalOpen}
      modalTitle="Update Filter"
      modalCloseHandler={props.closeHandler}
    >
      <Stack
        direction="column"
        sx={{ margin: '16px 0', width: '100%', gap: '16px' }}
      >
        <StyledSelectField
          label="Select Parameter"
          placeHolderText="Select Parameter"
          selectedValue={parameter}
          selectOptions={[
            { value: 'MTTR', label: 'MTTR' },
            { value: 'MTBF', label: 'MTBF' }
          ]}
          onChangeHandler={(valueObj) => setParameter(valueObj)}
          isMulti={false}
          isDisabled={false}
        />
        <Stack sx={{ gap: '8px' }}>
          <Typography>Filter Options (in minutes)</Typography>
          <StyledTextArea
            rows={5}
            value={filterMins}
            placeholder="Example: 30, 70, 180"
            onChange={(e) => setFilterMins(e.target.value)}
          />
        </Stack>
      </Stack>
      <Stack
        spacing={2}
        direction="row"
        sx={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}
      >
        <Button variant="outlined" onClick={props.closeHandler}>
          Cancel
        </Button>
        <Button
          disabled={parameter.value === 0 || !filterMins}
          variant="contained"
          sx={{
            color: '#fff',
            '&:disabled': {
              cursor: 'not-allowed'
            }
          }}
          onClick={handleSave}
        >
          Save
        </Button>
      </Stack>
    </StyledModal>
  )
}

export default AddMttrMtbfFilterModal
